import React from 'react';
import { Typography, Tooltip, useTheme, Box } from '@mui/material';
import CurlyCheckIcon from '../../assets/icons/CurlyCheckIcon';
import EclipseIcon from '../../assets/icons/EclipseIcon';
import SkipNext from '@mui/icons-material/SkipNext';
import { useResolutionScale } from '../../hooks';
import CrossIcon from '../../assets/icons/CrossIcon';


export const useTorqueColumns = (isDisplayOverallParamsFalse = false) => {
  const theme = useTheme();
  const { scaleValue } = useResolutionScale();
  const isDark = theme.palette.mode === 'dark';

  const successColor = isDark ? '#4CAF50' : '#1EBF36';
  const errorColor = isDark ? '#FF6B81' : '#CB1D49';

  const baseTextStyle = {
    fontWeight: 800,
    fontSize: scaleValue(22),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    lineHeight: `${scaleValue(26)}px`,
  };

  return [
    {
      field: 'parameterKey',
      title: 'Parameter Name',
      minWidth: 140,
      align: 'center',
      flex: 1,
      render: (row) => (
        <Tooltip title={row.parameterKey}>
          <Typography
            sx={{
              ...baseTextStyle,
              color: 'text.primary',
            }}
          >
            {row.parameterKey}
          </Typography>
        </Tooltip>
      ),
    },

    {
      title: 'Status',
      field: 'status',
      width: 140,
      align: 'center',
      render: (row, theme) => {
        const isDark = theme.palette.mode === 'dark';
        const size = scaleValue(22);

        const quantity = row.quantity ?? row.executionStatuses?.length ?? 1;
        const statuses = row.executionStatuses || []; // ✅ FIX

        const renderIcon = (mesParameterStatus, index) => {
          if (mesParameterStatus === true) {
            return (
              <CurlyCheckIcon
                key={index}
                style={{ width: size, height: size, color: '#1EBF36' }}
              />
            );
          }

          if (mesParameterStatus === false) {
            return (
              <CrossIcon
                key={index}
                style={{ width: size, height: size, color: '#CB1D49' }}
              />
            );
          }

          if (mesParameterStatus === 'skipped') {
            return (
              <SkipNext
                key={index}
                style={{ width: size, height: size, color: '#1B681B' }} // Distinct green/blue for skip
              />
            );
          }

          return (
            <EclipseIcon
              key={index}
              style={{
                width: size,
                height: size,
                color: isDark ? '#B0B0B0' : '#9E9E9E',
                opacity: 0.6,
              }}
            />
          );

        };

        const completedCount = statuses.filter((s) => s === true || s === 'skipped').length;

       return (
          <Box
            sx={{
              display: 'flex',
              gap: 0.5,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {Array.from({ length: quantity }).map((_, i) =>
              renderIcon(statuses[i], i)
            )}
          </Box>
        );
      },
    }


  ];
};
